module.exports = __webpack_public_path__ + "static/open-prs-ff1e865ffa87fd532de2eaf19c690b51.png";